import { ReactNode } from "react";
import { ToastProps } from "./Toast.types";

interface ToastManagerType {
	success: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	) => string;
	error: (message: string | ReactNode, options?: Partial<ToastProps>) => string;
	warning: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	) => string;
	info: (message: string | ReactNode, options?: Partial<ToastProps>) => string;
}

// Global toast manager instance
let toastManager: ToastManagerType | null = null;

// Function to set the toast manager instance (called by ToastProvider)
export const setToastManager = (manager: ToastManagerType) => {
	toastManager = manager;
};

// Function to clear the toast manager instance
export const clearToastManager = () => {
	toastManager = null;
};

// Global toast functions that can be used anywhere
export const toast = {
	success: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	): string => {
		if (!toastManager) {
			console.warn(
				"Toast manager not initialized. Make sure ToastProvider is rendered."
			);
			return "";
		}
		return toastManager.success(message, options);
	},

	error: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	): string => {
		if (!toastManager) {
			console.warn(
				"Toast manager not initialized. Make sure ToastProvider is rendered."
			);
			return "";
		}
		return toastManager.error(message, options);
	},

	warning: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	): string => {
		if (!toastManager) {
			console.warn(
				"Toast manager not initialized. Make sure ToastProvider is rendered."
			);
			return "";
		}
		return toastManager.warning(message, options);
	},

	info: (
		message: string | ReactNode,
		options?: Partial<ToastProps>
	): string => {
		if (!toastManager) {
			console.warn(
				"Toast manager not initialized. Make sure ToastProvider is rendered."
			);
			return "";
		}
		return toastManager.info(message, options);
	}
};
